import React from "react";

const ModalPopup = ({ show, onClose, children, modalClassName }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none">
      <div className="absolute inset-0" />
      <div className={`relative bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-2xl w-full max-w-lg mx-2 animate-fadeIn pointer-events-auto ${modalClassName || ''}`} style={{ boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)' }}>
        <button
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 text-2xl focus:outline-none"
          onClick={onClose}
          aria-label="Close dialog"
        >
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default ModalPopup;
